import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/resources/$id/")({
  staticData: {
    title: "apps.resources",
  },
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/resources/$id/general", params });
  },
});
